import * as React from 'react'
import Link from '@mui/material/Link'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import Divider from '@mui/material/Divider'
import HelpIcon from '@mui/icons-material/HelpOutlined'
import LibraryBooksIcon from '@mui/icons-material/LibraryBooksOutlined'
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined'
import ScatterPlotOutlinedIcon from '@mui/icons-material/ScatterPlotOutlined'
import InfoIcon from '@mui/icons-material/InfoOutlined'
import ExitToApp from '@mui/icons-material/ExitToApp'
import AccountBox from '@mui/icons-material/AccountBox'
import PsychologyAltOutlinedIcon from '@mui/icons-material/PsychologyAltOutlined'

import routes from '../../routes'
import {
    appMarketingSiteLabel,
    isKeywordGraphApp,
} from '../../appVariant'

export default function MenuItemsNotAuthUser() {
    const isKeywordGraph = isKeywordGraphApp()

    return [
        <MenuItem component={Link} href={routes.infranodus} key="marketing-site">
            <ListItemIcon>
                <ScatterPlotOutlinedIcon fontSize="small" />
            </ListItemIcon>
            {appMarketingSiteLabel()}
        </MenuItem>,
        isKeywordGraph ? null : (
            <MenuItem
                component={Link}
                href={routes.aboutInfranodus}
                key="aboutInfranodus"
            >
                <ListItemIcon>
                    <PsychologyAltOutlinedIcon fontSize="small" />
                </ListItemIcon>
                About InfraNodus
            </MenuItem>
        ),
        <Divider key="divider-login" />,
        <MenuItem
            component={Link}
            href={isKeywordGraph ? '/learn' : routes.userGuide}
            key="userGuide"
        >
            <ListItemIcon>
                <LibraryBooksIcon fontSize="small" />
            </ListItemIcon>
            User Guide
        </MenuItem>,
        <MenuItem component={Link} href={routes.support} key="support">
            <ListItemIcon>
                <HelpIcon fontSize="small" />
            </ListItemIcon>
            Support
        </MenuItem>,
        <MenuItem component={Link} href={routes.methodology} key="methodology">
            <ListItemIcon>
                <InfoIcon fontSize="small" />
            </ListItemIcon>
            Methodology
        </MenuItem>,
        <MenuItem
            component={Link}
            href={routes.joinCommunity}
            key="joinCommunity"
        >
            <ListItemIcon>
                <PeopleOutlinedIcon fontSize="small" />
            </ListItemIcon>
            Join the Community
        </MenuItem>,
        <Divider key="divider-login" />,
        <MenuItem component={Link} href={routes.signup} key="signup">
            <ListItemIcon>
                <AccountBox fontSize="small" />
            </ListItemIcon>
            Sign Up
        </MenuItem>,
        <MenuItem component={Link} href={routes.login} key="login">
            <ListItemIcon>
                <ExitToApp fontSize="small" />
            </ListItemIcon>
            Log In
        </MenuItem>,
    ]
}
